var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- components/bill-info/component--><h3>Счет № {{ modal_title }}</h3><table v-on=\"click: onClick\" v-if=\"data.table\" class=\"custom_table\"><thead><tr><th>Наименование</th><th>Кол.</th><th>Цена</th><th>Сумма</th><th>НДС</th><th>Итого с НДС</th></tr></thead><tfoot><tr><td colspan=\"6\">Всего: {{ summa | currency '' }}&nbsp;руб.</td></tr></tfoot><tbody><tr v-repeat=\"data.table\"><td>{{{* tovar | parseCntLinks }}}</td><td>{{* count }}</td><td>{{* price | currency '' }}&nbsp;руб.</td><td>{{* summa | currency '' }}&nbsp;руб.</td><td>{{* NDS | currency '' }}&nbsp;руб.</td><td>{{* summaNDS | currency '' }}&nbsp;руб.</td></tr></tbody></table><component is=\"alert\" name=\"bill-info\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/bill-info/component.jade
 ** module id = 42
 ** module chunks = 0
 **/